import { FC } from "react";
import { Box, Drawer, IconButton, SvgIcon, Typography } from "@mui/material";
import { ArrowBack, ChevronLeft, ChevronRight, Tune } from "@mui/icons-material";
import { useLocation } from "react-router";
import { FormattedMessage } from "react-intl";

import { IUser } from "@framework/types";
import { useAsu } from "@framework/provider-asu";
import { useUser } from "@framework/provider-user";

import { Equipment } from "./equipment";

export const drawerWidth = 320;

// TODO: delete if #8710 be cloced
// export const multiAnalysisDrawerWidth = 380;
// export const getActiveDrawerWidth = (tab: string): number => (tab === "6" ? multiAnalysisDrawerWidth : drawerWidth);
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const getActiveDrawerWidth = (tab: string): number => drawerWidth;

export const MainMenu: FC = () => {
  const { isMenuOpen, setIsMenuOpen, selectStation, selectedItem, tab } = useAsu();
  const location = useLocation();
  const { profile } = useUser<IUser>();

  const isDashboard = location.pathname.startsWith("/dashboard");

  const isItemHasParent = selectedItem?.ParentId;
  const activeDrawerWidth = getActiveDrawerWidth(tab);

  if (!isDashboard || !profile) {
    return null;
  }

  const toggleMenu = () => {
    setIsMenuOpen((prev: boolean) => !prev);
  };

  const handleBack = () => {
    if (selectedItem?.ParentId) {
      selectStation(selectedItem.ParentId);
    }
  };

  return (
    <Box
      sx={{
        position: "relative",
        ml: 3,
      }}
    >
      <IconButton
        sx={{
          svg: { color: "#0042B0" },
          backgroundColor: "#FFFFFF",
          border: "1px solid #F0F0FA",
          boxShadow: "0px 8px 16px rgba(49, 57, 102, 0.12)",
          zIndex: "1300",
          position: "fixed",
          left: isMenuOpen ? activeDrawerWidth : 56,
          top: 64,
          "&:hover": {
            backgroundColor: "#363846",
            border: "1px solid #363846",
            boxShadow: "0px 8px 16px rgba(49, 57, 102, 0.12)",
            svg: {
              color: "#FFFFFF",
            },
          },
        }}
        onClick={toggleMenu}
      >
        {isMenuOpen ? <ChevronLeft /> : <ChevronRight />}
      </IconButton>
      <Drawer
        sx={{
          width: isMenuOpen ? activeDrawerWidth : 56,
          flexShrink: 0,
        }}
        PaperProps={{
          sx: {
            width: isMenuOpen ? activeDrawerWidth : 56,
            height: "calc(100% - 96px)",
            boxSizing: "border-box",
            mt: "88px",
            borderRadius: "8px",
            ml: 3,
            mb: "8px",
            border: "none",
          },
        }}
        variant="permanent"
        open={isMenuOpen}
      >
        <Box
          sx={{
            display: isMenuOpen ? "flex" : "none",
            flexDirection: "column",
            justifyContent: "space-between",
            height: "100%",
            border: "1px solid #ebebf7",
            borderRadius: "8px",
            overflow: "auto",
          }}
        >
          <Equipment />
        </Box>
        {isMenuOpen ? null : (
          <Box
            sx={{
              height: "calc(100% - 88px)",
              borderRadius: "8px",
              border: "1px solid #ebebf7",
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "space-between",
              flex: 1,
            }}
          >
            <Box
              sx={{
                backgroundColor: "#FFFFFF",
                display: "flex",
                flex: 1,
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <Box>
                <Box sx={{ backgroundColor: "#0042b0", p: 2, pb: 1 }}>
                  <SvgIcon sx={{ color: "#fff" }}>
                    <Tune />
                  </SvgIcon>
                </Box>
                <Box sx={{ mt: 1, display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <IconButton onClick={handleBack} disabled={!isItemHasParent}>
                    <SvgIcon sx={{ color: "#363846", opacity: isItemHasParent ? 1 : 0.5 }}>
                      <ArrowBack />
                    </SvgIcon>
                  </IconButton>
                </Box>
              </Box>
              <Box
                sx={{
                  transform: "rotate(-90deg)",
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Typography fontWeight={700} fontSize={18} lineHeight="20px" color="#363846">
                  <FormattedMessage id="components.mainMenu.equipments" />
                </Typography>
              </Box>
            </Box>
          </Box>
        )}
      </Drawer>
    </Box>
  );
};
